/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from "react";
import classes from "./ModalOnboardingFinish.module.scss";
import modalCloseButton from "./../../../assets/images/onboarding/modal_close_button.svg";
import afinandoTourComplete from "./../../../assets/images/onboarding/afinando_tour_complete.svg";

const ModalOnboardingFinish = ({
  setRun,
  openModalFinish,
  setOpenModalFinish,
}) => {
  const [content, setContent] = useState(true);

  useEffect(() => {
    setContent(
      openModalFinish ? (
        <div className={classes.WrapModal}>
          <div className={classes.ModalDefault}>
            <div className={classes.ModalDefaultTop}>
              <div className={classes.Title}>{"Prontinho!"}</div>
              <button
                className={classes.ButtonClose}
                onClick={() => {
                  localStorage.setItem("onboarding", "viewed");
                  setOpenModalFinish(false);
                  setRun(false);
                }}
              >
                <img src={modalCloseButton} alt="close button" />
              </button>
            </div>
            <div className={classes.ModalDefaultBottom}>
              <div className={classes.ModalTextArea}>
                Agora você está por dentro do Afinando
              </div>
              <div className={classes.ModalTextArea}>
                Sempre que quiser, é só acessar novamente o tour guiado, que fica localizado dentro do menu superior direito
              </div>
              <img src={afinandoTourComplete} alt="close button" />
              <button
                onClick={() => {
                  localStorage.setItem("onboarding", "viewed");
                  setOpenModalFinish(false);
                  setRun(false);
                }}
                className={classes.ButtonStartTour}
              >
                Ok, ir para o início
              </button>
            </div>
          </div>
        </div>
      ) : null
    );
  }, [openModalFinish]);

  return content;
};
export default ModalOnboardingFinish;
